import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from './global.service';
import { map, catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { Subject, Observable } from 'rxjs';
import { Http, ResponseContentType } from '@angular/http';

const devUrl = environment.backendurl


@Injectable({
  providedIn: 'root'
})

 
export class CandidateService {
  similarcandidate : any;

  constructor(private http: HttpClient , private httpdata: Http) { }

  public candidatecreatedata: Subject<any> = new Subject(); 
  public candidateduplicateid: Subject<any> = new Subject(); 



  //get Candidate List  
  getCandidateList(data){
    let url = devUrl + "/getallcandidatedetails"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Get Candidate List', url)))
  }


//Get Single Candidate Details
  getCandidateDetails(candidateid){ 
    let url = devUrl + "/getcandidatedetails?updatedextension=true&candidatenumber="+candidateid
    return this.http.get(url).pipe(
      map(response => { return response; })
      , catchError(GlobalService.handleError('Get Candidate Details', url)))
  }

  //create Candidate
  createCandidate(data){
    var url = devUrl + "/addcandidate"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Create Candidate', url)));
  }

  //update Candidate Details
  updateCandidateDetails(data){
    var url = devUrl + "/updatebasicdetails"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Update Candidate Basic Details', url)));
  }

//update Candidate Experience Details
updateCandidateExperience(data){
  var url = devUrl + "/updateexperiencedetails"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Update Candidate Experience Details', url)));
}

//remove Candidate Experience Details
removeCandidateExperience(data){
  var url = devUrl + "/removeexperiencedetails"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Remove Candidate Experience Details', url)));
}

//update Candidate Education Details
updateCandidateEducation(data){
  var url = devUrl + "/updateeducationdetails"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Update Candidate Education Details', url)));
}

//remove Candidate Education Details
removeCandidateEducation(data){
  var url = devUrl + "/removeeducationdetails"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Remove Candidate Education Details', url)));
}


//update Candidate ADditional Details
updateCandidateAdditional(data){
  var url = devUrl + "/updateadditionaldetails"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Update Candidate Additional Details', url)));
}


//get Candidate ACtivity
getCandidateActivity(data){
  var url = devUrl + "/candidate/getcandidateactivity"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Candidate Activity', url)));
}

//check duplicate candidate
checkduplicatecandidate(data){
  var url = devUrl + "/checkduplicate"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Check Duplicate Candidate ', url)));
}


//show candidate contact details
premiumcontactenrichment(data){
  var url = devUrl + "/candidate/premiumcontactenrichment"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('premiumcontactenrichment ', url)));
}

fetchpremiumenrichmentstatus(data){
  var url = devUrl + "/candidate/fetchpremiumenrichmentstatus"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('fetchpremiumenrichmentstatus ', url)));
}


public createCandidateData (): void {
  this.candidatecreatedata.next();
}

public GetCreatedCandidateData (): Observable<any> {
  return this.candidatecreatedata.asObservable();
}



public passduplicatecandidateid (candidateid) {
  this.candidateduplicateid.next(candidateid);
}

public getduplicatecandidateid (): Observable<any> {
  return this.candidateduplicateid.asObservable();
}


//update candidate pipeline status
updatepipelineStatus(data){
  var url = devUrl + "/talentpipeline/updatecandidatepipelinestatus"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('update candidate pipeline status', url)));
}


getContactDetails(data){
  var url = devUrl + "/candidate/fetchexistingcontactdetails"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('fetch contact details', url)));
}

updatecontactDetails(data){
  var url = devUrl + "/candidate/updatecontactdetails"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('fetch contact details', url)));
}

deleteContactDetails(data){
  var url = devUrl + "/candidate/removecontactdetails"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('fetch contact details', url)));
}

fetchcandidatedetailsforcsvdownload(data){
  var url = devUrl + "/candidate/fetchcandidatedetailsforcsvdownload"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('fetch candiate details for csv download', url)));
}

makeContactsPrimary(data){
  var url = devUrl + "/candidate/assignprimarycontactdetail"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('assignprimarycontactdetail', url)));
}

deletecandidatedetails(data){
  var url = devUrl + "/candidate/deletedetails"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('deletecandidatedetails', url)));
}

uploadresume(data) {
  let formData: FormData = new FormData();
  // formData.append('text', 'resume');
  formData.append('document', data);
  var url =devUrl + "/candidate/uploaddocument"
  return this.http.post(url, formData).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Document Upload', url)));
}

removeuploadeddocuments(data) {
  var url = devUrl + "/candidate/removeuploadeddocuments"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('removeuploadeddocuments', url)));
}

savecvfiles(data) {
  var url = devUrl + "/candidate/savecvfiles"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('savecvfiles', url)));
}

fetchcvdetails(candidateid){ 
  let url = devUrl + "/candidate/fetchcvdetails?candidatenumber="+candidateid
  return this.http.get(url).pipe(
    map(response => { return response; })
    , catchError(GlobalService.handleError('fetchcvdetails', url)))
}

resumeurl(filename) {
  var url = devUrl + "/candidate/fetchdocument?documenturl="+filename
  return this.httpdata.get(url, { responseType: ResponseContentType.Blob }).pipe(
    map(response => { return new Blob([response.blob()], { type: 'application/pdf' }) }
        , catchError(GlobalService.handleError('resumeurl', url))));
}

  passSimilarCandidateData (data) {
  this.similarcandidate = data
}

  getSimilarCandidateData () {
  return this.similarcandidate
}

showallcontactdetails(data){
  var url = devUrl + "/showallcontactdetails"
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('showfreecontactdetails', url)));
}


addandenrichwithpartnercredits(data){
  var url = devUrl + "/candidate/addandenrichwithpartnercredits";
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('addandenrichwithpartnercredits', url)));
}

bulkrevealbasiccontacts(data){
  var url = devUrl + "/candidate/bulkrevealbasiccontacts";
  return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('bulkrevealbasiccontacts', url)));
}

getjobListTypeahead(data){
  let url = devUrl + "/typeahead/jobtitle"
  return this.http.post(url,data).pipe(map(resp => {return resp; }),
  catchError(GlobalService.handleError('Typeahead Job title','url'))
  );
}

getCandidateNameTypeahead(data){
  let url = devUrl + "/typehead/candidatename";
  return this.http.post(url, data).pipe(map(resp => {return resp; }),
  catchError(GlobalService.handleError('Typeahead Candidate Name','url'))
  ); 
}

getLocationTypeahead(data){
  let url = devUrl + "/typeahead/location"
  return this.http.post(url, data).pipe(map(resp => {return resp; }),
  catchError(GlobalService.handleError('Typeahead Location','url'))
  ); 
}

  bulkGrabCandidate(data) {
    const url = devUrl + "/searchtoolbox/bulkgrab";
    return this.http.post(url, data).pipe(map(resp => {return resp; }),
    catchError(GlobalService.handleError('Bulk Grabbed Failed','url'))
    );
  }

  deleteAllCandidates(data) {
    const url = devUrl + "/candidate/deletedetails";
    return this.http.post(url, data).pipe(map(resp => {return resp; }),
    catchError(GlobalService.handleError('Delete Candidates','url'))
    );
  }

  getCompanyTypeahead(data){
    let url = devUrl + "/typeahead/companyname"
    return this.http.post(url, data).pipe(map(resp => {return resp; }),
    catchError(GlobalService.handleError('Typeahead company','url'))
    ); 
  }

  createupdatetags(data) {
    let url = devUrl + "/candidate/tag"
    return this.http.post(url, data).pipe(map(resp => {return resp; }),
    catchError(GlobalService.handleError('Typeahead company','url'))
    ); 
  }


  gettags(candidatenumber: string) {
    let url = devUrl + "/candidate/tags?candidatenumber="+candidatenumber
    return this.http.get(url).pipe(map(resp => {return resp; }),
    catchError(GlobalService.handleError('Typeahead company','url'))
    ); 
  }

  updatetags(data) {
    let url = devUrl + "/candidate/updatetags"
    return this.http.put(url, data).pipe(map(resp => {return resp; }),
    catchError(GlobalService.handleError('Typeahead company','url'))
    );
  }

  previewcontactdetails(elasticid) {
    let url = devUrl + "/personsearch/previewcontactdetails?elasticid="+elasticid
    return this.http.get(url).pipe(map(resp => {return resp; }),
    catchError(GlobalService.handleError('Typeahead company','url'))
    );
  }

  revealcontact(data) {
    let url = devUrl + "/personsearch/revealcontact"
    return this.http.put(url, data).pipe(map(resp => {return resp; }),
    catchError(GlobalService.handleError('Typeahead company','url'))
    );
  }

  typeaheadTags(data) {
    let url = devUrl + "/typeahead/tags"
    return this.http.post(url, data).pipe(map(resp => {return resp; }),
    catchError(GlobalService.handleError('Typeahead company','url'))
    );
  }

  gettypedtags(tagtext: string) {
    let url = devUrl + "/tags?tagtext="+tagtext
    return this.http.get(url).pipe(map(resp => {return resp; }),
    catchError(GlobalService.handleError('Typeahead company','url'))
    );
  }

  archivecandidatesnotes(data:any) {
    let url = devUrl + "/candidate/archivecandidatenote"
    return this.http.put(url, data).pipe(map(resp => {return resp; }),
    catchError(GlobalService.handleError('Typeahead company','url'))
    );
  }

  


  
  
}
